import { Inject, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { EventBusFacade } from "remote-module-context";

import { DataBus } from "./data-bus";
import { AuthEffects } from "./effects/auth-effects";
import { CustomerEffects } from "./effects/customer-effects";
import { DepositLimitEffects } from "./effects/deposit-limit-effects";
import { KycEffects } from "./effects/kyc-effects";
import { NavigationEffects } from "./effects/navigation-effects";
import { PageEffects } from "./effects/page-effects";
import { WalletEffects } from "./effects/wallet-effects";
import { EventBus } from "./event-bus";
import {
	T_DATA_BUS,
	T_EVENT_BUS,
	T_REMOTE_MODULE_LOADER,
	T_SHELL_DATA_BUS_FACADE,
	T_SHELL_EVENT_BUS_FACADE,
} from "./injection";
import { RemoteModuleFactory } from "./remote-module.factory";

@NgModule({
	imports: [
		EffectsModule.forFeature([
			DepositLimitEffects,
			WalletEffects,
			PageEffects,
			NavigationEffects,
			AuthEffects,
			CustomerEffects,
			KycEffects,
		]),
	],
	providers: [
		{ provide: T_DATA_BUS, useValue: new DataBus() },
		{ provide: T_EVENT_BUS, useValue: new EventBus() },
		{
			provide: T_SHELL_DATA_BUS_FACADE,
			useFactory: (dataBus: DataBus) => dataBus.createFacade(),
			deps: [T_DATA_BUS],
		},
		{
			provide: T_SHELL_EVENT_BUS_FACADE,
			useFactory: (eventBus: EventBus, remoteModuleFactory: RemoteModuleFactory) =>
				eventBus.createFacade("shell", (identifier) => remoteModuleFactory.create(identifier)),
			deps: [T_EVENT_BUS, RemoteModuleFactory],
		},
		{
			provide: T_REMOTE_MODULE_LOADER,
			useFactory: (remoteModuleFactory: RemoteModuleFactory) => (identifier: string) =>
				remoteModuleFactory.create(identifier),
			deps: [RemoteModuleFactory],
		},
	],
})
export class CommunicationSystemModule {
	constructor(@Inject(T_SHELL_EVENT_BUS_FACADE) eventBus: EventBusFacade) {
		// mark shell as ready to receive events
		eventBus.dispatch({ channel: "shell", event: "ready" });
	}
}
